import { ACCEPT_IMG_ONLY, ACCEPT_IMG_PDF, MAX_FILE_SIZE } from "utils/constants/commonValues";


export const UBO_CREATE_FORM_NAME = 'ubo-details';
export const UBO_ACCORDIAN_NAME = 'uboDetails';
export const UBO_SECTION_TYPE = 'ownershipDetailSection';
export const MERCHANT_SECTION_TYPE = 'merchantDetailSection';
export const uboDeclarationUrls = {
    name: 'ubodeclarationsFile',
    label: 'Upload UBO Declarations',
    type: 'file',
    reqname: 'uboDeclarationUrls',
    fieldValidations: {
        required: true
    },
    place: 1
};
export const uboFields = {
    uboActive: {
        name: (fieldName) => `${fieldName}.status`,
        label: 'UBO Active',
        type: 'text',
        required: true,
        default: false,
        fieldValidations: {
            // required: true,
        },
        place: 13
    }, 
    uboName: {
        name: (fieldName) => `${fieldName}.name`,
        label: 'UBO Name',
        type: 'text',
        required: true,
        fieldValidations: {
            required: true,
            // alphaValid: true
        },
        place: 1,
        infoMsgs: 'Please update new pan in case of ubo name change'
    },
    panDate: {
        name: (fieldName) => `${fieldName}.panDetails.dob`,
        label: 'UBO Date of Birth',
        type: 'date',
        required: true,
        fieldValidations: {
            required: true,
        },
        place: 5
    },
    panUpload: {
        name: (fieldName) => `${fieldName}.panurl`,
        reqname: (fieldName) => `${fieldName}.panDetails.url`,
        label: 'UBO PAN Document',
        type: 'file',
        required: true,
        maxFileSize: MAX_FILE_SIZE,
        accept: ACCEPT_IMG_PDF,
        fieldValidations: {
            required: false,
        },
        class: 'upload-pan-class',
        place: 2
    },
    pan: {
        name: (fieldName) => `${fieldName}.panDetails.panNumber`,
        label: 'UBO PAN Number',
        type: 'text',
        required: true,
        fieldValidations: {
            required: true,
            panValid: true
        },
        place: 3
    },
    panName: {
        name: (fieldName) => `${fieldName}.panDetails.name`,
        label: 'UBO PAN Name',
        type: 'text',
        required: true,
        fieldValidations: {
            required: true,
        },
        place: 4,
        infoMsgs: 'Please update legal name as PAN Name is updating'
    },
    uboAddress: {
        name: (fieldName) => `${fieldName}.address.addressLine`,
        label: 'UBO Address',
        type: 'text',
        required: true,
        fieldValidations: {
            required: true,
        },
        place: 9,
        infoMsgs: 'Please verify your address and update proof of address'
    },
    uboDistrict: {
        name: (fieldName) => `${fieldName}.address.district`,
        label: 'District',
        type: 'select',
        required: true,
        disabled: true,
        fieldValidations: {
            required: true,
        },
        place: 7
    },
    uboState: {
        name: (fieldName) => `${fieldName}.address.state`,
        label: 'State',
        type: 'select',
        required: true,
        fieldValidations: {
            required: true,
        },
        place: 8
    },
    uboPincode: {
        name: (fieldName) => `${fieldName}.address.pinCode`,
        label: 'PIN Code',
        type: 'number',
        required: true,
        fieldValidations: {
            required: true,
        },
        place: 6,
        infoMsgs: 'Please verify your pincode and update proof of address'
    },
    uboPoA: {
        name: (fieldName) => `${fieldName}.addressProof`,
        label: 'UBO Proof Of Address',
        type: 'select',
        required: true,
        fieldValidations: {
            required: true,
        },
        place: 11
    },
    uboEmail: {
        name: (fieldName) => `${fieldName}.email`,
        label: 'UBO Email',
        type: 'text',
        required: true,
        fieldValidations: {
            emailValid: true,
        },
        place: 10
    },
    uploadUboPoA: {
        reqname: (fieldName) => `${fieldName}.addressProofUrls`,
        name: (fieldName) => `${fieldName}.addressFile`,
        label: 'UBO Proof Of Address Document',
        type: 'file',
        required: true,
        accept: ACCEPT_IMG_PDF,
        fieldValidations: {
            required: true,
        },
        place: 12
    },
    verifyPan: {
        name: (fieldName) => `${fieldName}.verify-pan`,
        label: 'Verify PAN',
        buttonType: 'primary',
        required: true,
        fieldValidations: {
            // required: true,
        }
    }
}

export const ERROR_UBO_ENABLE = 'At least one UBO must be active.';